<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userBinFenSeedFarmForm"
            :model="userBinFenSeedFarmForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="24">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userBinFenSeedFarmForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userBinFenSeedFarmName">
                    <Input v-model="userBinFenSeedFarmForm.userBinFenSeedFarmName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="关联苗场"
                    prop="userBinFenSeedFarmRelateFarmUuid">
                    <Select v-model="userBinFenSeedFarmForm.userBinFenSeedFarmRelateFarmUuid"
                        filterable>
                        <Option v-for="item in seedFarmSource"
                            :key="item.seedFarmUuid"
                            :value="item.seedFarmUuid">{{ item.seedFarmCode +"-"+ item.seedFarmName }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userBinFenSeedFarmPhone">
                    <Input v-model="userBinFenSeedFarmForm.userBinFenSeedFarmPhone"></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="24">
                <Col span="6">
                <FormItem label="是否主账号">
                    <RadioGroup v-model="userBinFenSeedFarmForm.isMainAccount"
                        type="button">
                        <Radio v-for="item in accountSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userBinFenSeedFarmForm.userBinFenSeedFarmApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <!-- <Col span="6">
                <FormItem label="是否场长账号">
                    <RadioGroup v-model="userBinFenSeedFarmForm.stat" type="button">
                        <Radio :label="true">是</Radio>
                        <Radio :label="false">否</Radio>
                    </RadioGroup>
                </FormItem>
                </Col> -->
            </Row>
            <Row :gutter="24">
                <Col span="6" v-if="formEditMode === FORM_EDIT_MODE_CREATE">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import {
    binFenSeedFarmUserSave,
    getBinFenSeedFarmUserDetail,
    pageInit4UserBinFenSeedFarmEdit
} from '@/api/modules/account-management/binFenSeedFarm-user-management';
import search from '@/libs/search';
export default {
    name: 'BinFenSeedFarmUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userBinFenSeedFarmForm: {
                userBinFenSeedFarmLoginUuid: '',
                userName: '',
                userBinFenSeedFarmName: '',
                userBinFenSeedFarmRelateFarmUuid: '',
                userBinFenSeedFarmContactNumber: '',
                userBinFenSeedFarmPhone: '',
                userBinFenSeedFarmWechat: '',
                userBinFenSeedFarmEmail: '',
                userBinFenSeedFarmApproval: APPROVAL_NO,
                isMainAccount: 0,
                stat: false
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userBinFenSeedFarmName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 2 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在2-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userBinFenSeedFarmRelateFarmUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userBinFenSeedFarmPhone: [
                    { pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确 ', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            seedFarmSource: [],
            approvalSource: [],
            accountlSource: [],
            isHasRight: 0
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        async init() {
            try {
                // 初始化源数据
                this.resetUserForm();
                this.initSourceData();
                // 加载页面数据
                await this.loadPageData();
                
            }
            catch (error) {
                console.error('初始化失败:', error);
                this.$Message.error('初始化数据失败，请重试');
            }
        },
        
        initSourceData() {
            this.approvalSource = [
                { val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) },
                { val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) }
            ];

            this.accountSource = [
                { val: 0, label: '子账号' },
                { val: 1, label: '主账号' }
            ];
        },
        resetUserForm() {
            this.userBinFenSeedFarmForm = {
                userBinFenSeedFarmLoginUuid: '',
                userName: '',
                userBinFenSeedFarmName: '',
                userBinFenSeedFarmRelateFarmUuid: '',
                userBinFenSeedFarmContactNumber: '',
                userBinFenSeedFarmPhone: '',
                userBinFenSeedFarmWechat: '',
                userBinFenSeedFarmEmail: '',
                userBinFenSeedFarmApproval: APPROVAL_NO,
                isMainAccount: 0,
                stat: false
            };
            this.password = '';
            this.passwordConfirm = '';
            this.isHasRight = 0;
        },
        
        async loadPageData() {
            this.$showGlobalSpin();
            
            try {
                const res = await pageInit4UserBinFenSeedFarmEdit();
                this.$hideGlobalSpin();
                
                if (res.code === 0) {
                    this.seedFarmSource = res.data.seedFarm.records.map(item => ({
                        seedFarmUuid: item.seedFarmUuid,
                        seedFarmName: item.seedFarmName,
                        seedFarmCode: item.seedFarmCode
                    }));
                    
                    if (this.accountUuid) {
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;
                        await this.loadUserDetail();
                    }
                    else {
                        this.$refs.userBinFenSeedFarmForm.resetFields();
                    }
                }
                else {
                    this.$Message.error(res.message || '页面初始化失败');
                }
            }
            catch (error) {
                this.$hideGlobalSpin();
                throw error;
            }
        },
        
        async loadUserDetail() {
            try {
                const detail = await getBinFenSeedFarmUserDetail(this.accountUuid);
                
                if (detail.code === 0) {
                    const info = detail.data.userBinFenSeedFarm;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmLoginUuid = info.userBinFenSeedFarmLoginUuid;
                    this.userBinFenSeedFarmForm.userName = info.userName;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmName = info.userBinFenSeedFarmName;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmRelateFarmUuid = info.userBinFenSeedFarmRelateFarmUuid;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmContactNumber = info.userBinFenSeedFarmContactNumber;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmPhone = info.userBinFenSeedFarmPhone;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmWechat = info.userBinFenSeedFarmWechat;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmEmail = info.userBinFenSeedFarmEmail;
                    this.userBinFenSeedFarmForm.userBinFenSeedFarmApproval = info.userBinFenSeedFarmApproval;
                    this.userBinFenSeedFarmForm.isMainAccount = info.isMainAccount;
                    this.userBinFenSeedFarmForm.stat = info.stat;
                    this.isHasRight = info.isHasRight;
                }
                else {
                    this.$Message.error(detail.message || '获取用户详情失败');
                }
            }
            catch (error) {
                this.$Message.error('获取用户详情失败，请重试');
                console.error('获取用户详情失败:', error);
            }
        },
        async onSave() {
            try {
                // 验证表单
                const valid = await this.validateForm();
                if (!valid) {
                    return;
                }

                // 构建提交数据
                const data = this.buildSubmitData();
                
                // 保存数据
                await this.saveData(data);
            }
            catch (error) {
                console.error('保存失败:', error);
                this.$Message.error('保存失败，请重试');
            }
        },
        
        validateForm() {
            return new Promise((resolve) => {
                this.$refs.userBinFenSeedFarmForm.validate(valid => {
                    if (!valid) {
                        this.$Message.error('表单验证失败!');
                        resolve(false);
                    }
                    else {
                        resolve(true);
                    }
                });
            }).catch(error => {
                console.error('表单验证异常:', error);
                this.$Message.error('表单验证异常');
                return false;
            });
        },
        
        buildSubmitData() {
            const data = Object.assign({ formEditMode: this.formEditMode }, this.userBinFenSeedFarmForm);
            
            if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                data.password = this.password;
                data.passwordConfirm = this.passwordConfirm;
            }
            
            return data;
        },
        
        async saveData(data) {
            this.$showGlobalSpin();
            
            try {
                const res = await binFenSeedFarmUserSave(data);
                this.$hideGlobalSpin();
                
                if (res.code === 0) {
                    await this.handleSaveSuccess();
                }
                else {
                    this.$Message.error(res.message || '保存失败');
                }
            }
            catch (error) {
                this.$hideGlobalSpin();
                throw error;
            }
        },
        
        handleSaveSuccess() {
            return new Promise((resolve) => {
                this.$Modal.success({
                    title: '保存成功',
                    onOk: () => {
                        this.show = false;
                        this.$parent.getBinFenSeedFarmUserTableRecords();
                        resolve();
                    }
                });
            }).catch(() => {
                // 处理用户取消的情况
                this.show = false;
                this.$parent.getBinFenSeedFarmUserTableRecords();
            });
        }
        
    }
};
</script>

<style scoped>
</style>
